const FALLBACK = "ผู้เรียน";
const THAI_TITLE = /^(นางสาว|เด็กหญิง|เด็กชาย|นาง|นาย|น\.ส\.|ด\.ญ\.|ด\.ช\.)\s*/u;

// Display reduction only: the callable and stored identity remain unchanged.
// Segmenter keeps combining marks attached. Older browsers fail safely closed.
export function maskPublicReviewName(value) {
  if (typeof value !== "string" || value.length > 500) return FALLBACK;
  const name = value.replace(/[\t\r\n]/gu, " ").trim().replace(/\s+/gu, " ");
  if (/[\p{Cc}\p{Cf}]/u.test(name)) return FALLBACK;
  if (!name || [FALLBACK, "ผู้เรียนคอร์ส"].includes(name) || typeof Intl.Segmenter !== "function") return FALLBACK;
  const title = name.match(THAI_TITLE)?.[1] || "";
  const body = name.slice(title.length).trim();
  // Reject contacts, digits, emoji, markup and controls rather than deriving a name.
  if (!/^[\p{L}\p{M}]+(?:[ '\u2019-][\p{L}\p{M}]+)*$/u.test(body)) return FALLBACK;
  const segmenter = new Intl.Segmenter("th", { granularity: "grapheme" });
  const parts = body.split(" ").map(word => Array.from(segmenter.segment(word), item => item.segment));
  if (parts.some(part => part.some(cluster => /^\p{M}/u.test(cluster)))) return FALLBACK;
  const first = parts[0], last = parts[parts.length - 1];
  const preferredPrefix = /\p{Script=Thai}/u.test(first[0]) ? 2 : 4;
  let prefixSize, suffixSize;
  if (parts.length === 1) {
    if (first.length < 4) return FALLBACK;
    prefixSize = Math.min(preferredPrefix, first.length - 2);
    suffixSize = Math.min(3, first.length - prefixSize - 1);
  } else {
    if (first.length < 2 || last.length < 2) return FALLBACK;
    // Conceal at least one cluster in both the first and last words, even for
    // very short surnames. All intermediate words are concealed in full.
    prefixSize = Math.min(preferredPrefix, first.length - 1);
    suffixSize = Math.min(3, last.length - 1);
  }
  const prefix = first.slice(0, prefixSize).join("");
  const suffix = last.slice(-suffixSize).join("");
  if (!/^[\p{L}\p{M}]+$/u.test(prefix) || !/^[\p{L}\p{M}]+$/u.test(suffix)) return FALLBACK;
  return `${title}${prefix}****${suffix}`;
}
